import Cert1 from "../../assets/certificates/cert1.png";
import Cert2 from "../../assets/certificates/cert2.jpg";
const Certificates = [
  {
    id: "1",
    img: Cert1,
    url: "https://smartinternz.com/internships/salesforce_certificates/477bdb55b231264bb53a7942fd84254d",
  },
  {
    id: "2",
    img: Cert2,
    url: "https://d8it4huxumps7.cloudfront.net/lambda-pdfs/certificate-images/94db780e-7b4b-463d-80ed-89f1257d9040.jpg",
  },
];
export default Certificates;
